import { CustomButton } from 'modules/auth/styles'
import { getCategories_action, getDrafts_action, saveCategory_action, toggleSettingsModal_action } from 'store/actions'
import { Fragment, useState } from 'react'
import { FiX } from 'react-icons/fi'
import { connect } from 'react-redux'
import { Label, ModalBody } from 'reactstrap'
import apiService from 'utils/apiService'
import { ButtonLoader } from 'utils/storageUtils'
import { colors, FileInputHidden, ImportTabs, ImportTabsContent, ModalForm } from '../../app/styles'
import { CategoriesSelector } from 'modules/pages/components/CategoriesSelector'
import { ReactComponent as ResponseIcon } from 'assets/images/icons/response.svg'
import { ReactComponent as PagesIcon } from 'assets/images/icons/pages.svg'
import { AiOutlineDownload } from 'react-icons/ai'
import { handleApiError, logAmplitudeEvent } from 'utils/helpers'
import { toast } from 'react-toastify'
import { ReactComponent as BackIcon } from 'assets/images/icons/back.svg'
import { BackButton } from 'modules/subscription/styles'
import * as XLSX from "xlsx";
import { Link } from 'react-router-dom'

export function ImportContent(props) {
  const { user, pages, responses } = props
  const [selectedCategory, setSelectedCategory] = useState({})
  const selectCategory = (category) => {
    if (selectedCategory.id === category.id) {
      setSelectedCategory({})
    } else {
      setSelectedCategory(category || {})
    }
  }

  const [contentType, setContentType] = useState('')
  const [activeTab, set_activeTab] = useState('')
  const switchTab = (e, tabName, contentType) => {
    e.preventDefault()
    set_activeTab(tabName)
    setContentType(contentType)
    setSelectedCategory({})
  }

  // Select file
  const [isUploading, set_isUploading] = useState(false)
  const [file, set_file] = useState(null)
  const importClick = async () => {
    try {
      set_isUploading(true)
      const uploadData = new FormData()
      uploadData.append('import_to', activeTab)
      uploadData.append('file', file)
      if (selectedCategory.id) uploadData.append('category_id', selectedCategory.id)
      await apiService('contents/importContent', uploadData, 'post', true, true)
      toast.success(`Data imported to ${selectedCategory.id ? selectedCategory.name : 'Uncategorized'}`)
      logAmplitudeEvent(`Imported content to ${activeTab}`)
      props.toggleSettingsModal(false)
      props.getDrafts()
    } catch (error) {
      handleApiError(error)
    }
    const fileElem = document.querySelector('#importExcel')
    if (fileElem) fileElem.value = ''
    set_file(null)
    set_isUploading(false)
  }

  const exportClick = async (e, activeTab, selectCategory) => {
    try {
      if (selectCategory.uuid) {
        const response = await apiService(`contents/exportContent?export_type=${activeTab}&category_uuid=${selectCategory.uuid}`, null, 'get', true)
        window.location.href = response.export_link
      } else {
        const response = await apiService(`contents/exportContent?export_type=${activeTab}`, null, 'get', true)
        window.location.href = response.export_link
      }
    } catch (e) {
      handleApiError(e)
    }
    e.preventDefault()
    setSelectedCategory({})
  }

    const downloadSampleSheet = () => {

    const workbook = XLSX.utils.book_new();

    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Title", "Content"],
      ["Title 1", "<div>Html Content 1</div>"],
      ["Title 2", "<div>Html Content 2</div>"],
      ["Title 3", "<div>Html Content 3</div>"],
    ]);
    XLSX.utils.book_append_sheet(workbook, worksheet, "sample-import");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    // Convert buffer to Blob
    const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    // Create download link
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "import_sample.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <Fragment>
      <ModalBody className='h-100'>
        <ModalForm tag='div' className={`${contentType === 'import' ? 'h-100' : 'h-50'} ${contentType === 'export' ? 'd-none' : 'd-flex'} flex-column`} style={{ maxWidth: 500 }}>
          <div className='title d-flex'>Import Content</div>
          <div className='my-auto d-flex flex-column' style={{ height: '90%' }}>
            {!activeTab && (
              <Fragment>
                <div className='font-weight-600 my-4'>Where do you want to save it?</div>
                <ImportTabs>
                  <a href='/' onClick={(e) => switchTab(e, 'page', 'import')} className={`${activeTab === 'page' ? 'active' : ''}`}>
                    <PagesIcon />
                    <div className='tab-name'>Pages</div>
                  </a>
                  <a href='/' onClick={(e) => switchTab(e, 'response', 'import')} className={`${activeTab === 'response' ? 'active' : ''}`}>
                    <ResponseIcon />
                    <div className='tab-name'>Responses</div>
                  </a>
                </ImportTabs>
              </Fragment>
            )}
            {activeTab === 'page' && contentType === 'import' && (
              <ImportTabsContent>
                <p className='font-weight-600'>Import to Pages:</p>
                {pages.shared_categories.length === 0 && pages.private_categories.length === 0 && (
                  <div className='text-center' style={{ background: colors['light-blue-100'] }}>
                    No page category found.
                  </div>
                )}
                {(pages.shared_categories.length > 0 || pages.private_categories.length > 0) && (
                  <CategoriesSelector
                    user={user}
                    selectCategory={(cat) => selectCategory(cat)}
                    preExpandedCategory={[]}
                    category={selectedCategory}
                    private_categories={pages.private_categories}
                    shared_categories={pages.shared_categories}
                    saveCategory={props.saveCategory}
                    type='page'
                    showNewCategoryForm={true}
                    getCategories={props.getCategories}
                  />
                )}
              </ImportTabsContent>
            )}
            {activeTab === 'response' && contentType === 'import' && (
              <ImportTabsContent>
                <p className='font-weight-600'>Import to Responses:</p>
                {responses.shared_categories.length === 0 && responses.private_categories.length === 0 && (
                  <div className='text-center' style={{ background: colors['light-blue-100'] }}>
                    No page category found.
                  </div>
                )}
                {(responses.shared_categories.length > 0 || responses.private_categories.length > 0) && (
                  <CategoriesSelector
                    user={user}
                    selectCategory={(cat) => selectCategory(cat)}
                    preExpandedCategory={[]}
                    category={selectedCategory}
                    private_categories={responses.private_categories}
                    shared_categories={responses.shared_categories}
                    saveCategory={props.saveCategory}
                    type='response'
                    showNewCategoryForm={true}
                    getCategories={props.getCategories}
                  />
                )}
              </ImportTabsContent>
            )}

            {activeTab !== '' && contentType === 'import' && (
              <div className='mt-auto'>
                <ul className='pl-4 my-4' style={{ listStyle: 'disc' }}>
                  <li>
                    Excel and CSV files should contain title and content columns.
                    <br />
                    
                    <Link to={"/"} onClick={downloadSampleSheet}>
                    <AiOutlineDownload /> Download Sample
                    </Link>

                  </li>
                </ul>
                <div className='d-flex'>
                  <FileInputHidden
                    id='importExcel'
                    type='file'
                    accept='.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    onChange={(e) => set_file(e.target.files.length > 0 ? e.target.files[0] : null)}
                  />
                  <BackButton
                    href='/'
                    onClick={(e) => {
                      e.preventDefault()
                      set_activeTab('')
                      setContentType('')
                    }}>
                    <BackIcon height={20} width={20} /> Back
                  </BackButton>
                  {!file && (
                    <Label className='mb-0 mx-auto' htmlFor='importExcel'>
                      <CustomButton tag='div' className='black'>
                        Select file
                      </CustomButton>
                    </Label>
                  )}
                  {file && (
                    <div className='d-flex justify-content-between align-items-center flex-fill'>
                      <CustomButton onClick={importClick} className='black' disabled={isUploading}>
                        Import {isUploading && <ButtonLoader />}
                      </CustomButton>
                      <div className='ml-3'>
                        <small>
                          {file.name}
                          <span
                            className='ml-3'
                            onClick={() => {
                              const fileElem = document.querySelector('#importExcel')
                              if (fileElem) {
                                fileElem.value = ''
                              }
                              set_file(null)
                            }}>
                            <FiX />
                          </span>
                        </small>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </ModalForm>
        <ModalForm tag='div' className={`${contentType === 'export' ? 'h-100' : 'h-50'} ${contentType === 'import' ? 'd-none' : 'd-flex'} flex-column`} style={{ maxWidth: 500 }}>
          <div className='title d-flex'>Export From:</div>
          <div className='my-auto d-flex flex-column justify-content-between' style={{ height: '90%' }}>
            {!activeTab && (
              <Fragment>
                <ImportTabs>
                  <a href='/' onClick={(e) => switchTab(e, 'page', 'export')} className={`${activeTab === 'page' ? 'active' : ''}`}>
                    <PagesIcon />
                    <div className='tab-name'>Pages</div>
                  </a>
                  <a href='/' onClick={(e) => switchTab(e, 'response', 'export')} className={`${activeTab === 'response' ? 'active' : ''}`}>
                    <ResponseIcon />
                    <div className='tab-name'>Responses</div>
                  </a>
                </ImportTabs>
              </Fragment>
            )}
            {activeTab === 'page' && contentType === 'export' && (
              <ImportTabsContent>
                <p className='font-weight-600'>Export from Pages:</p>
                {pages.shared_categories.length === 0 && pages.private_categories.length === 0 && (
                  <div className='text-center' style={{ background: colors['light-blue-100'] }}>
                    No page category found.
                  </div>
                )}
                {(pages.shared_categories.length > 0 || pages.private_categories.length > 0) && (
                  <CategoriesSelector
                    user={user}
                    selectCategory={(cat) => selectCategory(cat)}
                    preExpandedCategory={[]}
                    category={selectedCategory}
                    private_categories={pages.private_categories}
                    shared_categories={pages.shared_categories}
                    saveCategory={props.saveCategory}
                    type='page'
                    showNewCategoryForm={false}
                    isExport={true}
                    getCategories={props.getCategories}
                  />
                )}
              </ImportTabsContent>
            )}
            {activeTab === 'response' && contentType === 'export' && (
              <ImportTabsContent>
                <p className='font-weight-600'>Export from Responses:</p>
                {responses.shared_categories.length === 0 && responses.private_categories.length === 0 && (
                  <div className='text-center' style={{ background: colors['light-blue-100'] }}>
                    No page category found.
                  </div>
                )}
                {(responses.shared_categories.length > 0 || responses.private_categories.length > 0) && (
                  <CategoriesSelector
                    user={user}
                    selectCategory={(cat) => selectCategory(cat)}
                    preExpandedCategory={[]}
                    category={selectedCategory}
                    private_categories={responses.private_categories}
                    shared_categories={responses.shared_categories}
                    saveCategory={props.saveCategory}
                    type='response'
                    showNewCategoryForm={false}
                    isExport={true}
                    getCategories={props.getCategories}
                  />
                )}
              </ImportTabsContent>
            )}
            {activeTab !== '' && contentType === 'export' && (
              <div className='d-flex mt-4'>
                <BackButton
                  href='/'
                  onClick={(e) => {
                    e.preventDefault()
                    set_activeTab('')
                    setContentType('')
                  }}>
                  <BackIcon height={20} width={20} /> Back
                </BackButton>
                <CustomButton onClick={(e) => exportClick(e, activeTab, selectedCategory)} className='black' disabled={isUploading}>
                  Export {!selectedCategory.id ? 'All' : `From ${selectedCategory.name ? selectedCategory.name : 'Private'}`} {isUploading && <ButtonLoader />}
                </CustomButton>
              </div>
            )}
          </div>
        </ModalForm>
      </ModalBody>
    </Fragment>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  app: state.app,
  responses: state.contents.responses,
  pages: state.contents.pages
})

const mapDispatchToProps = (dispatch) => ({
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  getCategories: () => dispatch(getCategories_action()),
  getDrafts: (filters) => dispatch(getDrafts_action(filters)),
  saveCategory: (data) => new Promise((resolve, reject) => dispatch(saveCategory_action(data, resolve, reject)))
})

export default connect(mapStateToProps, mapDispatchToProps)(ImportContent)
